<pc-image-banner 
    [imgUrl]="this.bannerImgUrl || ''"
>
</pc-image-banner>

<div class="site-gutter white-gutter">
    <div class="main-copy-section">
        <div class="wrapper">
            <div class="copy-container">
                <div class="header-container">
                    <h1>Metals, Wood & Plastics Wall and Ceilings Services</h1>
                </div>
                <p>
                    PC Haines performs two different types of services, exterior & interior. Our exterior services include cold-formed metal framing & trusses with engineered blast resistant designs, plywood & gypsum sheathing, air/vapor barriers, cladding support systems, column covers and linear metal ceilings. 
                </p>
                <p>
                    Our interior services include non-structural metal framing, shaft wall assemblies, fiberglass & mineral wool insulation, various types of gypsum board (Type-X, Abuse, Tile Backer) with level 1 to level 5 finishes to receive paint or vinyl graphics & wall coverings, plastic paneling (FRP), acoustical panel ceilings, monolithic acoustical gypsum ceilings, wood veneer wall panels, fabric-wrapped wall panels, wood grille ceilings, and sound-absorbing ceiling units.
                </p>
                <p> 
                    We work as a skilled team to bring you top-quality workmanship in the divisions listed below. Click on each division to learn more about the services we offer and be sure to browse through our project gallery to see photos of our work.  
                </p>
            </div>
            <div class="circles services-circles">
                <pc-services-circles></pc-services-circles>
            </div>
        </div>
    </div>
</div>

<div class="secondary-content-section dark-section">
    <div class="site-gutter">
        <div class="card-container">
            <div class="card-row">
                <div class="card">
                    <div class="header-container">
                        <h3>Division 5</h3>
                        <h4>Metals</h4>
                    </div>
                    <p>Division 5 provided services include 054000 - Cold-Formed Metal Framing, 054400 - Cold-Formed Metal Trusses and 055813 - Metal Column Covers.</p>

                    <a routerLink="/services/division-5" class="learn-more">Learn More</a>
                </div>

                <div class="card">
                    <div class="header-container">
                        <h3>Division 6</h3>
                        <h4>Wood & Plastics</h4>
                    </div>
                    <p>Division 6 provided services include 061000 - Rough Carpentry, 061600 - Sheathing and 066400 - Plastic Paneling</p>

                    <a routerLink="/services/division-6" class="learn-more">Learn More</a>
                </div>
            </div>

            <div class="card-row">
                <div class="card">
                    <div class="header-container">
                        <h3>Division 7</h3>
                        <h4>Thermal & Moisture</h4>
                    </div>
                    <p>Division 7 provided services include 070543 - Cladding Support Systems, 072100 - Thermal Insulation, 072500 - Weather Barriers, 072715 - Self-Adhering Air Barriers, 074213 - Metal Soffit Panels, 078413 - Penetration Fireproofing and 079200 - Joint Sealants.</p>

                    <a routerLink="/services/division-7" class="learn-more">Learn More</a>
                </div>

                <div class="card">
                    <div class="header-container">
                        <h3>Division 9</h3>
                        <h4>Finishes</h4>
                    </div>
                    <p>Division 9 provided services include 092216 - Non-Structural Metal Framing, 092116 - Gypsum Board Shaft Wall Assemblies, 092900 - Gypsum Board, 095113 - Acoustical Panel Ceilings, 095126 - Beam & Baffle Ceiling Systems, 095423 Linear Metal Ceilings, 095426 - Suspended Wood Ceilings, 095813 - Monolithic Acoustical Ceilings, 097714 - Wood Veneer Wall Panels, 097723 - Fabric-Wrapped Panels and 098450 - Wood Panel Grill Wall System.</p>

                    <a routerLink="/services/division-9" class="learn-more">Learn More</a>
                </div>
            </div>
            <div class="card-row">
                <div class="card">
                    <div class="header-container">
                        <h3>Division 10</h3>
                        <h4>Specialties</h4>
                    </div>
                    <p>Division 10 provided services include 102641 - Ballistic Resistan Panels</p>

                    <a routerLink="/services/division-10" class="learn-more">Learn More</a>
                </div>
                <div class="card"></div>
            </div>
        </div>
    </div>
</div>

<pc-seat-belt
    [copy]="'Ready to experience the PC Haines difference? Submit a bid request today.'"
    [buttonText]="'Submit a Request'"
    [buttonUrl]="'/contact-us'"
    [urlFragment]="'bid-request'"
></pc-seat-belt>